export default __webpack_public_path__ + "static/media/Image-16.a3fc10c9.png";